import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';

import {Text} from '../../../../../../../component/text/text';
import {AiChatMessageRoleEnum} from '../../../../../../../service/reivew-analysis/review-analysis-ai-chat/review-analysis-ai-message-type';
import {classNames} from '../../../../../../../util/css';

import * as styles from './ai-chat-message.scss';

type AiAnalysisMessagePropsType = {
    role: AiChatMessageRoleEnum;
    title?: string;
    message: string;
    typing?: boolean;
};

export function AiChatMessage(props: AiAnalysisMessagePropsType): JSX.Element {
    const {role, message, title, typing} = props;

    const cleanedMessage = message.trim().replaceAll('\n\n', '\n');

    return (
        <div
            className={classNames(styles.AiAnalysisMessage_wrapper, {
                [styles.AiAnalysisMessage_wrapper__userMessage]: role === AiChatMessageRoleEnum.USER,
            })}
        >
            <div
                className={classNames(styles.AiAnalysisMessage_messageCloud, {
                    [styles.AiAnalysisMessage_messageCloud__userMessage]: role === AiChatMessageRoleEnum.USER,
                    [styles.AiAnalysisMessage_messageCloud__systemGreeting]: role === AiChatMessageRoleEnum.SYSTEM,
                })}
            >
                {title && (
                    <Text block bolder className={styles.AiAnalysisMessage_title}>
                        {title}
                    </Text>
                )}
                <Text
                    block
                    className={classNames(styles.AiAnalysisMessage_message, {
                        [styles.AiAnalysisMessage_message__typing]: typing,
                    })}
                >
                    <Markdown
                        components={{
                            // eslint-disable-next-line react/no-unstable-nested-components
                            table: ({className: tableClassName, ...restTableProps}) => (
                                <div className={styles.AiAnalysisMessage__scrollableBlock}>
                                    <table
                                        className={classNames(styles.AiAnalysisMessage__table, tableClassName)}
                                        /* eslint-disable-next-line react/jsx-props-no-spreading */
                                        {...restTableProps}
                                    />
                                </div>
                            ),

                            // eslint-disable-next-line react/no-unstable-nested-components
                            pre: (preProps) => (
                                <div className={styles.AiAnalysisMessage__scrollableBlock}>
                                    {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                                    <pre {...preProps} />
                                </div>
                            ),
                            // eslint-disable-next-line react/no-unstable-nested-components
                            code: (codeProps) => (
                                <div className={styles.AiAnalysisMessage__scrollableBlock}>
                                    {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                                    <code {...codeProps} />
                                </div>
                            ),
                            // eslint-disable-next-line react/no-unstable-nested-components
                            img: (imgProps) => (
                                <div className={styles.AiAnalysisMessage__scrollableBlock}>
                                    {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                                    <img alt="" {...imgProps} />
                                </div>
                            ),
                        }}
                        rehypePlugins={[rehypeRaw]}
                        remarkPlugins={[remarkGfm]}
                    >
                        {cleanedMessage}
                    </Markdown>
                </Text>
            </div>
        </div>
    );
}
